<template>
  <Multiselect
    v-model="model"
    :options="options"
    :track-by="trackBy"
    :label="label"
    :selectLabel="selectLabel"
    :deselectLabel="deselectLabel"
  />
</template>
<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  components: {
    Multiselect,
  },
  props: {
    value: [String, Number],
    options: Array,
    label: String,
    selectLabel: String,
    deselectLabel: String,
    trackBy: String,
  },
  computed: {
    model: {
      get() {
        return this.findInValueOptions(this.value);
      },
      set(val) {
        if (val) {
          this.$emit('input', val[this.trackBy]);
        } else {
          this.$emit('input', null);
        }
      },
    },
  },
  methods: {
    findInValueOptions(val) {
      let result = null;
      this.options.forEach((option) => {
        if (option[this.trackBy] === val) {
          result = option;
        }
      });
      return result;
    },
  },
};
</script>
<style lang="scss">
  .multiselect{
    min-height: 43px;
    box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02) !important;
    border: 0 !important;
    border-radius: 0.375rem;

    .multiselect__tags{
      min-height: 43px;
      padding-top: 12px;
      border: 0;
      color:#8898aa;
    }

    .multiselect__select{
      padding-top: 13px;
    }
  }
</style>
